export default __webpack_public_path__ + "locales/cs/InfoPanel.json?hash=de4695f0a57e0a96a6e2ac2d8765b488";